module.exports = __webpack_public_path__ + "img/icon_navi_setting.366f4d20.svg";